// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XMMIH","newExpiryDate":"styles_newExpiryDate__1oC7j","footer":"styles_footer__3SBlv"};